import { CircularProgress, Box, Typography, Paper } from '@mui/material';

export default function LoadingOverlay({ message = 'Procesando su solicitud' }) {
  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: 'rgba(255, 255, 255, 0.7)',
        backdropFilter: 'blur(4px)',
        zIndex: 9999,
      }}
    >
      <Paper
        elevation={5}
        style={{
          padding: '30px 40px',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          borderRadius: '16px',
          maxWidth: '400px',
        }}
      >
        <CircularProgress color="success" size={80} thickness={4} />
        <Box mt={3} textAlign="center">
          <Typography variant="h6" gutterBottom>
            {message}
          </Typography>
          <Typography variant="body1" color="textSecondary">
            Por favor espere y no cierre esta ventana. La operación puede tardar unos momentos.
          </Typography>
        </Box>
      </Paper>
    </div>
  );
}
